export default "__VITE_ASSET__6b2ac3d8__"